import {RoleDto} from "../../services/klaraApi";
import Enumerable from "linq";

export default function checkIsAdmin(roles: Array<RoleDto>) {
    return Enumerable.from(roles).any(t => t.isAdmin);
}